/* eslint-disable @typescript-eslint/no-explicit-any */
import {post, get} from 'utils/axios/index'
// import {toast} from 'react-toastify'
import ApiResponse, {
 DefaultApiResponse,
} from 'models/ApiResponse'
import {AxiosError, AxiosRequestHeaders} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFileUpload, PreSignedURL} from 'models/Common'

const uploadFile = async (formData: any) => {
 try {
  const res = await post<DefaultApiResponse>(
   '/common/v1/file-upload',
   formData,
   {},
   {
    'Content-Type': 'multipart/form-data',
   } as unknown as AxiosRequestHeaders
  )
  return res.data
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchSignedUrl = async (formData: IFileUpload) => {
 try {
  const data = await get<ApiResponse<PreSignedURL>>(
   '/common/v1/file-upload',
   {...formData}
  )
  return data
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export {uploadFile, fetchSignedUrl}
